import React, { useEffect, useState } from 'react';
import { apiService } from '../../../services/api';
import { AREA_LABEL, ChangeRow, describeChange } from './types';
import * as fmt from '../../../lib/format';

// Who changed which standard, and what it was before. Covers every editor: these tabs, Naming rules
// and Flow. Newest first.
export default function ChangeLog({ refreshKey }: { refreshKey: number }) {
  const [rows, setRows] = useState<ChangeRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiService
      .getStandardsChangelog(50)
      .then((r) => {
        if (cancelled) return;
        if (r.success) {
          setRows(r.data);
          setError(null);
        } else setError(r.error || 'Could not load the change log');
      })
      .catch((e: any) => !cancelled && setError(e?.response?.data?.error || 'Could not load the change log'));
    return () => {
      cancelled = true;
    };
  }, [refreshKey]);

  return (
    <section className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-gray-200/70" aria-labelledby="std-log">
      <h3 id="std-log" className="text-sm font-semibold text-gray-900">Recent changes</h3>
      <p className="mt-0.5 text-xs text-gray-500">Every change to a standard, from this tab, Naming rules and Flow. Changes apply to every month, so last month's figures can move after an edit; this is where to see when and why.</p>
      {error && <p className="mt-3 text-sm text-rose-700" role="alert">{error}</p>}
      {rows === null && !error ? (
        <div className="mt-4 h-24 animate-pulse rounded-xl bg-gray-100 motion-reduce:animate-none" role="status" aria-label="Loading the change log" />
      ) : rows && rows.length === 0 ? (
        <p className="mt-4 rounded-xl bg-gray-50 px-4 py-6 text-center text-sm text-gray-500">No change has been made yet.</p>
      ) : (
        <ol className="mt-4 divide-y divide-gray-100">
          {(rows ?? []).map((c) => (
            <li key={c.id} className="flex flex-wrap items-baseline gap-x-3 gap-y-1 py-2.5 text-sm">
              <span className="w-28 shrink-0 text-xs tabular-nums text-gray-500">{fmt.dateTime(c.changed_at)}</span>
              <span className="shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-[0.6875rem] font-medium text-gray-600">{AREA_LABEL[c.area]}</span>
              <span className="min-w-0 flex-1 text-gray-800">{describeChange(c)}</span>
              <span className="shrink-0 text-xs text-gray-500">{c.changed_by ?? 'unknown'}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
